module.exports = __webpack_public_path__ + "img/daqiuzhuangyuan.632f4346.png";